import { TabPanel, TabView } from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';

export default class WrappedTabView extends React.Component {
	renderContent = () => {
		const { tabItems } = this.props;

		return tabItems.map(({ header, disabled, content, headerClassName }) => {
			// user header to build key
			const key = header.split(' ').join('').toLowerCase();

			return (
				<TabPanel
					header={header}
					disabled={disabled}
					key={key}
					headerClassName={headerClassName}
				>
					{content}
				</TabPanel>
			);
		});
	};

	render() {
		const {
			className,
			dataqa = 'ui-tabview',
			activeIndex,
			onTabChange,
		} = this.props;

		return (
			<div className="common-ui-tabview">
				<TabView
					className={className}
					activeIndex={activeIndex}
					onTabChange={onTabChange}
					data-qa={dataqa}
					dataqa={dataqa}
				>
					{this.renderContent()}
				</TabView>
			</div>
		);
	}
}

WrappedTabView.propTypes = {
	tabItems: PropTypes.array,
};
